import RateIntelligenceIndex from "../../pages/dashboard/rate-intelligence/RateIntelligenceIndex";
import { ALL_ROUTES } from "../AllRoutes";

export const rate_intelligence_routes_group = [
  {
    path: ALL_ROUTES?.DASHBOARD_RATE_INTELLIGENCE,
    element: RateIntelligenceIndex,
  },
];
